export default __webpack_public_path__ + "static/media/login-form-image.8e551328.png";